import { render, staticRenderFns } from "./ExportTabs.vue?vue&type=template&id=c53c94f4&scoped=true&"
import script from "./ExportTabs.vue?vue&type=script&lang=js&"
export * from "./ExportTabs.vue?vue&type=script&lang=js&"
import style0 from "./ExportTabs.vue?vue&type=style&index=0&id=c53c94f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53c94f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})
